import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  useReducer,
} from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  Inputs,
  DatePickerComponent,
  AutocompleteComponent,
} from "../../../../../../Components";
import { getErrorByName } from "../../../../../../Helper";

export const ClientsTrackingContentDialog = ({
  data,
  state,
  setState,
  selected,
  setSelected,
  translationPath,
  parentTranslationPath,
  GetLookupItemsByNames,
  isSubmitted,
  schema,
}) => {


  const onChangeHandler = (key, values, selectedObj, selectedValues) => {
    if (!selectedObj) {
      setState({ id: [key], value: values });
    } else {
      setState({ id: [key], value: values });
      setSelected({ id: [selectedObj], value: selectedValues });
    }
  };

  const { t } = useTranslation(parentTranslationPath);

  const searchTimer = useRef(null);

  return (
    <div className="d-flex flex-wrap justify-content-between">
      <div className="px-2 mt-2 w-50">
        <Inputs
          idRef="serviceidRef"
          labelValue={t(`${translationPath}service-id`)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          isDisabled
          value={state?.serviceId}
        />
      </div>
      <div className="px-2 mt-2 w-50">
        <Inputs
          idRef="serviceNameRef"
          labelValue={t(`${translationPath}service-name`)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          isDisabled
          value={state?.serviceName || ""}
        />
      </div>
      <div className="px-2 mt-2 w-50">
        <Inputs
          idRef="clientidRef"
          labelValue={t(`${translationPath}client-id`)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          isDisabled
          value={state?.contactId || ""}
        />
      </div>

      <div className="px-2 mt-2 w-50">
        <Inputs
          idRef="clientNameRef"
          labelValue={t(`${translationPath}client-name`)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          isDisabled
          value={state?.contactName}
        />
      </div>
      
      <div className="px-2 mt-2 w-50">
        <Inputs
          idRef="vendorName"
          labelValue={t(`${translationPath}vendor-name`)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          isDisabled
          value={state?.vendorName || ""}
        />
      </div>

      <div className="px-2 mt-2 w-50">
        <Inputs
          idRef="vendorIdRef"
          labelValue={t(`${translationPath}vendor-id`)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          isDisabled
          value={state?.vendorId}
        />
      </div>
      <div className="px-2 mt-2 w-50">
        <Inputs
          idRef="vendorOfferNameRef"
          labelValue={t(`${translationPath}vendor-offer`)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          isDisabled
          value={state?.vendorOfferName}
        />
      </div>
      <div className="px-2 mt-2 w-50">
        <DatePickerComponent
          idRef="createdOnRef"
          labelValue="creation-on"
          placeholder="DD/MM/YYYY"
          value={state?.createdOn || ""}
          parentTranslationPath={parentTranslationPath}
          isDisabled
          translationPath={translationPath}
          onDateChanged={(newValue) => {}}
        />
      </div>
      <div className="px-2 mt-2 w-50">
        <Inputs
          idRef="serviceCategoryRef"
          labelValue={t(`${translationPath}service-category`)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          isDisabled
          value={state?.vendorServiceCategoryName || ""}
        />
      </div>

      <div className="mt-2 w-50">
        <AutocompleteComponent
          idRef="psiCommissionStatusRef"
          labelClasses="Requierd-Color"
          labelValue="psi-commission-status"
          selectedValues={selected?.psiCommissionStatus}
          multiple={false}
          data={data?.psiCommissionStatus || []}
          displayLabel={(option) => option.lookupItemName || ""}
          getOptionSelected={(option) =>
            option.lookupItemId === state?.psiCommissionStatusId
          }
          withoutSearchButton
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          onChange={(event, newValue) => {
            onChangeHandler(
              "psiCommissionStatusId",
              newValue?.lookupItemId || null,
              "psiCommissionStatus",
              newValue
            );
          }}
          isSubmitted={isSubmitted}
          helperText={getErrorByName(schema, "psiCommissionStatusId").message}
          error={getErrorByName(schema, "psiCommissionStatusId").error}
          isWithError
        />
      </div>
      <div className="px-2 mt-2 w-50">
        <Inputs
          idRef="psiCommissionPercentageteRef"
          labelValue={t(`${translationPath}psi-commission-percentagete`)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          isDisabled
          value={state?.psiCommissionPercentage || ""}
        />
      </div>
      <div className="px-2 mt-2 w-50">
        <Inputs
          idRef="discountPercentageRef"
          labelValue={t(`${translationPath}discount-percentage`)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          isDisabled
          value={state?.discountPercentage || ""}
        />
      </div>
      <div className="px-2 mt-2 w-50">
        <AutocompleteComponent
          idRef="transactionStatusClientTrackingRef"
          labelClasses="Requierd-Color"
          labelValue="transaction-status"
          selectedValues={selected?.transactionStatus}
          multiple={false}
          data={data?.transactionStatusClientTracking || []}
          displayLabel={(option) => option.lookupItemName || ""}
          getOptionSelected={(option) =>
            option?.lookupItemId === state?.transactionStatusId
          }
          withoutSearchButton
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          onChange={(event, newValue) => {
            onChangeHandler(
              "transactionStatusId",
              newValue?.lookupItemId || null,
              "transactionStatus",
              newValue
            );
          }}
          isSubmitted={isSubmitted}
          helperText={getErrorByName(schema, "transactionStatusId").message}
          error={getErrorByName(schema, "transactionStatusId").error}
          isWithError
        />
      </div>
      <div className="px-2 mt-2 w-50">
        <Inputs
          idRef="invoiceNumberRef"
          labelValue={t(`${translationPath}invoice-number`)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          value={state?.invoiceId || ""}
          type="number"
          min={0}
          onInputChanged={(event) => {
            let  value = event && event.target && event.target.value;
            if (value && value !== "" && parseInt(value) < 0) {
              value = parseInt(value) * -1;
            }
            onChangeHandler(
              "invoiceId",
              value === '' ?  null : parseInt(value)  || null
              
            );         
           }}
        />
      </div>
      <div className="px-2 mt-2 w-50">
        <Inputs
          idRef="transactionAmountRef"
          labelValue={t(`${translationPath}transaction-amount`)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          value={state?.transactionAmount || ""}
          type="number"
          withNumberFormat
          onInputChanged={(event) => {
            let value = event && event.target && event.target.value;
            if (value && value !== "" && parseFloat(value) < 0) {
              value = parseFloat(value) * -1;
            }
            onChangeHandler(
              "transactionAmount",
              value === '' ?  null : parseFloat(value)  || null
              
            );         
           }}
        />
      </div>
      <div className="px-2 mt-2 w-50">
        <Inputs
          idRef="clientFeedbackRef"
          labelValue={t(`${translationPath}client-feedback`)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          isDisabled
          value={state?.clientFeedback || ""}
        />
      </div>
      <div className="px-2 mt-2 w-50">
        <Inputs
          idRef="qrCodeRef"
          labelValue={t(`${translationPath}qr-code`)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          isDisabled
          value={state?.qrCode || ""}
        />
      </div>

      <div className="px-2 mt-2 w-50">
        <Inputs
          idRef="promoCodeRef"
          labelValue={t(`${translationPath}promo-code`)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          isDisabled
          value={state?.promoCode || ""}
        />
      </div>
     
    </div>
  );
};
